import { FC } from 'react';
import { useIntl } from 'react-intl';
import { VideoPlayer } from 'src/components';
import {
  CheckpointCelebrationVideo,
  localizeCelebrationTranslation,
} from 'src/apps/QuickReview/celebrationVideos';
import { useEosCelebrationVideo } from '../useEosCelebrationVideo';
import * as S from './styles';

export type CongratulationVideoBannerProps = {
  video?: CheckpointCelebrationVideo;
};

/**
 * Banner played at the top of the Path learn end-of-session screen: cycles through
 * celebratory Learn with Locals clips for the learner's language pair.
 */
export const CongratulationVideoBanner: FC<CongratulationVideoBannerProps> = ({
  video: videoOverride,
}) => {
  const intl = useIntl();
  const selectedVideo = useEosCelebrationVideo();
  const video = videoOverride ?? selectedVideo;

  if (!video) return null;

  return (
    <S.BannerWrap data-testid="congratulation-video-banner">
      <S.Stage>
        <VideoPlayer src={video.src} playOnKeyboardShortcut={false} autoPlay />
      </S.Stage>
      <S.Caption>
        <S.Phrase dir="auto">{video.phrase}</S.Phrase>
        <S.Translation dir="auto">
          {localizeCelebrationTranslation(video.translation, intl.locale)}
        </S.Translation>
      </S.Caption>
    </S.BannerWrap>
  );
};
